<script setup lang="ts">
import { RenderAddress } from '@hfc/ui-core';

withDefaults(defineProps<{
  lineOne?: string,
  lineTwo?: string,
  city?: string,
  state?: string,
  zip?: string,
  id: number | null,
  title: string,
  active?: boolean,
  titleClass?: string,
}>(), {
  lineOne: '',
  lineTwo: '',
  city: '',
  state: '',
  zip: '',
  active: false,
  titleClass: '',
});

interface EmitsInterface {
  (event: 'selectAddress', value: number | null): void
}

const emits = defineEmits<EmitsInterface>();

const selectAddress = (value: number | null): void => {
  emits('selectAddress', value);
};

</script>
<template>
  <div class="w-full md:w-1/2 py-2 md:p-2">
    <p class="mb-1" :class="titleClass">{{ title }}</p>
    <div class="flex">
      <div class="rounded-lg px-3 py-3 cursor-pointer w-full" @click="selectAddress(id)" :class="{ 'light:border-blue-500 border-[3px] light:bg-blue-100': active, 'border light:border-gray-500 light:text-gray-400': !active }">
        <RenderAddress :two-lines="true" :line-one="lineOne" :line-two="lineTwo" :city="city" :state="state" :zip="zip" :icon-color="active ? 'text-gray-400' : ''" />
      </div>
    </div>
  </div>
</template>
